export default __webpack_public_path__ + "static/media/ks2 day.a44d20c5.jpg";